// extracted by css-extract-rspack-plugin
export default {"dl":"DefinitionList__dl--zGoaL","dt":"DefinitionList__dt--PRAhW","withSeparator":"DefinitionList__withSeparator--JAg7B","dd":"DefinitionList__dd--oJ3W1"};